export class Receipt {
  id: string;
  number: number;
  operationNumber: number;
  currency: string;
  amount: number;
  receivingBank: string;
  issuingBank: string;
  issuingBankNumber: number;
  observation: string;
  transferDate: Date;
  name: string;
  url: string;
  file: File;

  constructor(receipt: {
    id?: string;
    number?: number;
    name?: string;
    url?: string;
    file?: File;
    operationNumber?: number;
    currency?: string;
    amount?: number;
    receivingBank?: string;
    issuingBank?: string;
    issuingBankNumber?: number;
    observation?: string;
    transferDate?: Date;
  }) {
    this.id = receipt.id;
    this.name = receipt.name;
    this.number = receipt.number;
    this.url = receipt.url;
    this.file = receipt.file;
    this.operationNumber = receipt.operationNumber;
    this.currency = receipt.currency;
    this.amount = receipt.amount;
    this.receivingBank = receipt.receivingBank;
    this.issuingBank = receipt.issuingBank;
    this.issuingBankNumber = receipt.issuingBankNumber;
    this.observation = receipt.observation;
    this.transferDate = receipt.transferDate;
  }
}
